module.exports = "/_next/static/images/mobilepay-25370282c2c875eed5203368ac6eb633.svg";